<template>
  <v-container grid-list-md pa-0 relative>
    <v-layout row wrap>
      <v-flex xs12 sm12>
        <v-card outlined class="primary--border">
          <v-card-title class="title">
            Destination & Fare
            <v-spacer></v-spacer>
            <add-button
              @action="
                (form.dialog = true),
                  getRoutes(),
                  $refs.form ? $refs.form.reset() : '',vehicles=[]
              "
              permission="fare-create"
            >
              Assign Fare
            </add-button>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="form.items.data"
            :options.sync="pagination"
            :footer-props="footerProps"
            :server-items-length="form.items.meta.total"
            :loading="form.loading"
          >
            <template v-slot:item="{ index, item }">
              <tr>
                <td>{{ index + form.items.meta.from }}</td>
                <td>{{ item.destination }}</td>
                <td>{{ item.rate }}</td>
                <td>
                  {{ item.route }}
                </td>
                <td>
                  <span v-if="item.vehicles.length > 0">
                    <v-chip
                      small
                      v-for="(vehicle, index) in item.vehicles"
                      :key="index"
                      :class="index === 0 ?'success white--text mr-2' : 'warning white--text mr-2'"
                      style="margin-top: 5px;"
                      >
                      <span v-if="index ===0">
                          Primary : {{ vehicle }} 
                      </span>
  
                      <span v-else>
                        Secondary : {{ vehicle }}
                      </span>
                    </v-chip>
                  </span>
                  <span v-else>
                    -
                  </span>
                </td>
                <td
                  class="text-right"
                  style="padding: 0 9px !important; min-width: 100px"
                >
                  <div class="btn_group">
                    <edit-button
                      permission="fare-update"
                      @agree="form.edit(item), getRoutes()"
                    />
                    <delete-button
                      permission="fare-delete"
                      @agree="deleteFare(item.id)"
                      />
                      <!-- @agree="form.delete(item.id)" -->
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>

      <v-dialog v-model="form.dialog" persistent max-width="800px">
        <v-card>
          <v-card-title class="primary white--text">
            <span class="title">Add/Update</span>
          </v-card-title>
          <v-card-text class="pb-1">
            <v-form
              ref="form"
              @submit.prevent="save"
              @keydown.native="form.errors.clear($event.target.name)"
              @keyup.enter="save"
              v-model="valid"
              :lazy-validation="lazy"
            >
              <br />

              <v-layout row wrap>
                <!--<v-flex xs12 sm12>-->
                <!--</v-flex>-->
                <v-flex xs8>
                  <v-text-field
                    autocomplete="off"
                    label="Destination name*"
                    required
                    class="pa-0 pl-2"
                    v-model="form.destination"
                    name="destination_name"
                    :error-messages="form.errors.get('destination')"
                    outlined
                    dense
                    :rules="[
                      (v) => !!v || 'Destination Name Field is required',
                    ]"
                  />
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    autocomplete="off"
                    type="number"
                    label="Fare amount*"
                    required
                    class="pa-0 pl-2"
                    v-model="form.rate"
                    name="fare_amount"
                    :error-messages="form.errors.get('rate')"
                    outlined
                    dense
                    :rules="[
                      (v) => !!v || 'Fare Amount Name Field is required',
                    ]"
                  />
                </v-flex>
                <v-flex xs7>
                  <v-select
                    :items="routes"
                    label="Route*"
                    required
                    class="pa-0 pl-2"
                    v-model="form.route_id"
                    name="route_name"
                    :error-messages="form.errors.get('route_id')"
                    outlined
                    dense
                  />
                </v-flex>

                <!-- <v-flex xs5>
                  <v-select
                    :disabled="vehicles.length < 1"
                    :items="vehicles"
                    label="Vehicle*"
                    required
                    class="pa-0 pl-2"
                    v-model="form.vehicle_id"
                    name="vehicle_id"
                    :error-messages="form.errors.get('vehicle_id')"
                    outlined
                    dense
                    :rules="[(v) => !!v || 'Route Name Field is required']"
                  />
                </v-flex> -->
                <v-flex xs12 sm12>
                  <v-data-table 
                    :headers="vehicleHeader"
                    hide-default-footer
                    :items="vehicles"
                   
                  > 
                  <!-- :items="vehicleForm.items.data"
                    :server-items-length="vehicleForm.items.meta.total"
                    :loading="vehicleForm.loading" -->
                    <template v-slot:item="{index, item}">
                      <tr>
                        <!-- <td>
                          <v-checkbox v-model="item.is_selected" :value="form.vehicle_id.includes(item.id)"  @click="toogleVehicleSelection(item,item.is_selected)"
                            class="ml-0"
                            primary
                            hide-details>
                          </v-checkbox>
                        </td> -->

                        <td>{{ item.text}} </td>
                        <td>{{ item.vehicle_number }}</td>
                        <td>
                          <v-chip
                            v-if="index === 0"
                            class="ma-2"
                            color="green" text-color="white"
                          >
                            Primary
                          </v-chip>
                         
                          <v-chip
                            v-else
                            class="ma-2"
                            color="warning" text-color="white"
                          >
                            Secondary
                          </v-chip>
                         
                          
                        </td>
                      </tr>
                    </template>

                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="warning"
              text
              @click="(form.dialog = false), form.reset(),vehicles=[]"
              >Close</v-btn
            >
            <v-btn color="success" text @click="validate">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<style scoped></style>
<script>
import Form from "@/library/Form";
import Mixins from "@/library/Mixins";
export default {
  mixins: [Mixins],
  name: "VehicleComponent",
  components: {
    // RemoveDialog
  },
  data: () => ({
    valid: true,
    lazy: false,
    form: new Form(
      {
        route_id: "",
        vehicle_id: [],
        destination: "",
        rate: "",
        // veh_id:[],
      },
      "api/fare"
    ),
    // vehicleForm:new Form({},"api/vehicle"),
    headers: [
      { text: "#", align: "left", value: "sno", sortable: false, width: 10 },
      { text: "Destination", align: "left", value: "name", sortable: false },
      { text: "Fare", align: "left", value: "serial", sortable: false },
      { text: "Route", align: "left", value: "type", sortable: false },
      { text: "Vehicle", align: "left", value: "vehicle", sortable: false },
      { text: "Action", align: "right", sortable: false },
    ],
    vehicleHeader:[
      // { text: "#", align: "left", value: "sno", sortable: false, width: 10 },
      { text: "Name", align: "left", value: "name", sortable: false },
      { text: "Vehiche Number", align: "left", value: "vehicle_num", sortable: false },
      { text: "Status", align: "left", value: "name", sortable: false },

    ],
    vehicles: [],
    pagination: {
      itemsPerPage: 25,
    },
    types: [
      { text: "Bus", value: "bus" },
      { text: "Van", value: "van" },
      { text: "Micro", value: "micro" },
    ],
    routes: [],
    routeColl: [],
    search: "",
  }),
  watch: {
    "form.route_id": function() {
      let $this = this;
      this.routeColl.forEach(function(route) {
        if ($this.form.route_id === route.id) {
          $this.vehicles = route.vehicles.map(function(v) {
            return { text: v.name, value: v.id , vehicle_number: v.vehicle_no};
          });
        }

      });
    },
    pagination: function() {
      this.get();
    },
  },
  computed: {},
  mounted() {
    // this.getVehicle();
    // this.get();
  },
  methods: {
    // toogleVehicleSelection(item,sel){
    //   if(sel){
    //     this.form.vehicle_id.push(item.id)
    //   }else{
    //     this.form.vehicle_id.pop(item.id)
    //   }
    // },
    validate() {
      if (this.$refs.form.validate()) {
        this.form.vehicle_id = this.vehicles.map(s=>s.value);

        this.store();
      }
    },
    // queryString() {
    //     let json = this.pagination;
    //     return '?' +
    //         Object.keys(json).map(function (key) {
    //             if (![null, undefined].includes(json[key]))
    //                 return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
    //         }).join('&');
    // },
    get(params) {
      let extraParams = "";
      let query = [null, undefined].includes(params)
        ? this.queryString(extraParams)
        : params;
      this.form.get(null, query).then(({ data }) => {
        this.pagination.totalItems = data.meta.total;
      });
    },
    store() {
      this.form.store();
    },
    getRoutes() {
      this.$rest.get("/api/route?rowsPerPage=50").then(({ data }) => {
        this.routeColl = data.data;
        let $this = this;
        this.routes = data.data.map((route) => {
          if ($this.form.route_id === route.id) {
            $this.vehicles = route.vehicles.map(function(v) {
              // return { text: v.name, value: v.id };
              return { text: v.name, value: v.id , vehicle_number: v.vehicle_no};
            });
          }
          return { text: route.name, value: route.id };
        });
        // this.form.vehicle_id = this.vehicles.map(s=>s.value);
        // console.log(this.form.vehicle_id,'vehid');
      });
    },
    deleteFare(id){
      this.form.delete(id).then((res)=>{
      }).catch((err)=>{
        if (err.response)
            this.$events.fire("notification", {
            message: err.response.data.message,
            status: "error",
        });
      })
    }
  },
};
</script>
